// src/services/AttachmentsService.js
import axios from 'axios'

const api = axios.create({
  baseURL: 'https://dashamajig.chibitronics.com/api',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  // list existing docs
  list(customerId) {
    return api.get(`/customers/${customerId}/attachments`)
  },

  // get S3 presign data
  // now takes an object: { filename, content_type }
  presign(customerId, { filename, content_type }) {
    return api.post(
        `/customers/${customerId}/attachments/presign`,
        { filename, content_type }
    )
  },

  // register uploaded object
  // now also sends content_type and byte_size
  register(customerId, { key, filename, content_type, byte_size }) {
    return api.post(
        `/customers/${customerId}/attachments`,
        { key, filename, content_type, byte_size }
    )
  },

  // delete an attachment
  delete(customerId, attachmentId) {
    return api.delete(
        `/customers/${customerId}/attachments/${attachmentId}`
    )
  }
}
